import { useUser } from 'context/User'

export default useUser
